import ComboBox from './src/combo-box.vue'

export default ComboBox
